import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OvertimeReport from "./Overtime";
import MonthlyOvertimeReport from "./Monthly_overtime";

/**
 * Wraps the Daily and Monthly overtime reports as tabs that toggle with state
 * (like the Loan Report) — both stay mounted, so switching is instant with no
 * route change and no reload.
 */
const OvertimeReportTabs = () => {
  const [activeTab, setActiveTab] = useState("daily");

  return (
    <div className="container-fluid mt-4">
      <ToastContainer position="bottom-right" />

      {/* Tabs */}
      <div className="mb-3 d-flex flex-wrap" style={{ gap: "10px" }}>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "daily" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("daily")}
        >
          Daily Overtime Report
        </button>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "monthly" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("monthly")}
        >
          Monthly Overtime Report
        </button>
      </div>

      {/* Both stay mounted; only the active one is shown */}
      <div style={{ display: activeTab === "daily" ? "block" : "none" }}>
        <OvertimeReport />
      </div>
      <div style={{ display: activeTab === "monthly" ? "block" : "none" }}>
        <MonthlyOvertimeReport />
      </div>
    </div>
  );
};

export default OvertimeReportTabs;
